export enum NavigationClickerModalType {
  Tasks = 'tasks',
  Improvements = 'improvements',
  Gifts = 'gifts',
  GiftsGameFinished = 'giftsGameFinished',
  GiftsGameMocks = 'giftsGameMocks',
  Leaderboard = 'leaderboard',
  LeaderboardGameFinished = 'leaderboardGameFinished',
  Daily = 'daily',
  FAQ = 'faq',
  BeforeResultsInfo = 'beforeResultsInfo',
  Settings = 'settings',
  GameStatistics = 'game-statistics',
  GameStatisticsMocks = 'game-statistics-mocks',
  Winners = 'winners',
}
